import {h, Component} from 'preact';
import {connect} from 'react-redux';
import $ from 'jquery';

import * as actions from '../actions';
import reduce from '../reducers';

import Spinner from './Spinner';

import designDomain from '../domain/designDomain';
import designService from '../service/designService';
import IllustrationConfirmModal from './IllustrationConfirmModal';
import ConfigureIllustrationModal from './ConfigureIllustrationModal';
import Masonry from 'react-masonry-component';
import constants from '../constants';
import util from "../util";
import FavoriteButton from './FavoriteButton';
import IllustrationCard from './card/IllustrationCard';

export default @connect(reduce, actions)
class AsideElements extends Component {
  constructor() {
    super();
    this.state = {
      illustrations: [],
      isUploadLoading: false,
      isLoading: false,
      isLoadingBatch: false,
      page: 0,
      pageSize: constants.INFINITE_LOAD_PAGE_SIZE,
      isSearching: false,

      isConfirmModalOpen: false,
      illustrationToConfigure: '',

      searchBy: '',
      folder: '',

      colors: [],
      objectCount: 0,
      additionalSize: 0.0,

      isSelectionMode: false,
      selectedIllustrations: [],
    };

    this.toggleSelected = this.toggleSelected.bind(this);

    this.onConfirmModalClose = () => {
      this.setState({
        isConfirmModalOpen: false
      })
    };

    this.confirmUpload = () => {
      this.setState({
        isUploadLoading: true,
        isConfirmModalOpen: false
      });

      const colors = this.state.colors
        .filter(it => it.isActive)
        .map(it => it.color);
      designService.confirmUploadIllustration(colors, this.props.designId).then(response => {
        this.setState({isUploadLoading: false});
        this.setState({illustrations: [new designDomain.DesignIllustration(response.data), ...this.state.illustrations]});
        this.forceUpdate();
      }, () => {
        this.setState({isUploadLoading: false});
        this.forceUpdate();
      })
    };

    this.toggleColor = (color) => {
      const colors = this.state.colors.slice();
      let i, length = colors.length;
      for (i = 0; i < length; i++) {
        const it = colors[i];
        if (it.color === color.color) {
          it.isActive = !it.isActive;
          break
        }
      }
      this.setState({colors})
    };

    this.toggleAllColors = () => {
      const colors = this.state.colors.slice();
      let toggleAllTrue = $('#toggleAllColorsCheckbox').prop('checked');
      colors.forEach(function (color) {
        color.isActive = toggleAllTrue;
      })
      this.setState({colors})
    };

    this.onImagesLoaded = () => {
    };

    this.infiniteLoadIllustrations = () => {
      const $scroller = $('#app-aside-illustrations').find('.scroller');
      const $illustrations = $('.illustrations');
      const top = $scroller.scrollTop();
      if (top >= $illustrations.height() - $scroller.height() - 150) {
        if (!this.state.isLoadingBatch) {
          this.setState(old => ({
            isLoadingBatch: true,
            page: old.page + 1
          }));

          util.nextTick(() => {
            designService.getDesignIllustrations(this.props.designId, this.state.page, this.state.searchBy, this.state.folder).then(response => {
              const illustrations = this.state.illustrations.concat(response.data.map(it => new designDomain.DesignIllustration(it)));
              this.setState({
                illustrations,
                isLoadingBatch: false
              })
            })
          });
        }
      }
    };

    this.showConfigureIllustrationModal = (illustration, event) => {
      if (!this.props.isDesigner) return;

      event.stopPropagation();

      designService.getIllustration(illustration.id).then(response => {
        const illustration = new designDomain.DesignIllustration(response.data);

        this.setState({illustrationToConfigure: illustration});
        this.props.showConfigureIllustrationModal();
      })
    };

    this.showConfigureMultiIllustrationModal = () => {
      if (!this.props.isDesigner) return;
      this.props.showConfigureIllustrationModal();
    }

    this.onConfigureIllustrationModalClose = () => {
      this.props.hideConfigureIllustrationModal();
      this.deselectAll();
    };

    this.trackSearch = () => {
      try {
        ga('send', 'pageview', '?i=' + this.state.searchBy);
      } catch (e) {
        console.log('> Was not possible to track search. Possibly because of a tracking blocker on the browser.');
        console.log(e);
      }
    };

    this.onChangeSearchField = (ev) => {
      this.setState({page: 0});
      this.setState({searchBy: ev.target.value});
      this.setState({folder: ''});

      if (!this.state.isSearching) {
        this.trackSearch();
      }

      this.setState({
        isSearching: true,
        isLoading: true,
        illustrations: []
      });

      designService.getDesignIllustrations(this.props.designId, 0, $('.search-templates').val(), this.state.folder).then(response => {
        this.setState({
          illustrations: response.data.map(it => new designDomain.DesignIllustration(it)),
          isLoading: false,
          isSearching: false
        });
      }).catch(() => {
        this.setState({
          isLoading: false,
          isSearching: false,
          illustrations: []
        })
      })
    };

    this.onClickDeleteInputSearch = () => {
      this.setState({page: 0});
      this.setState({searchBy: ''});
      this.setState({folder: ''});
      $('#delete-icon').hide();

      if (!this.state.isSearching) {
        this.trackSearch();
      }

      this.setState({
        isSearching: true,
        isLoading: true,
        illustrations: []
      });

      designService.getDesignIllustrations(this.props.designId, this.state.page, '', this.state.folder).then(response => {
        this.setState({
          illustrations: response.data.map(it => new designDomain.DesignIllustration(it)),
          isLoading: false,
          isSearching: false
        });
      }).catch(() => {
        this.setState({
          isLoading: false,
          isSearching: false,
          illustrations: []
        })
      })
    };

    this.init = () => {
      this.setState({isLoading: true});

      $('.folders').on('scroll', () => {
        util.checkScroll($('.folders'));
      });
      $('.scroll-left').hide();

      let promise = designService.getDesignIllustrations(this.props.designId);

      promise.then(response => {
        let illustrationsData = response.data.map(it => new designDomain.DesignIllustration(it));
        illustrationsData = illustrationsData.filter(it => it.id !== "");
        this.setState({illustrations: illustrationsData});
        this.setState({isLoading: false});
      })
    };

    this.getIllustrationsByFolder = (folder) => {
      $('.search-templates').val('');

      this.setState(() => ({
        page: 0,
        folder,
        searchBy: '',
        isSearching: true,
        isLoading: true,
        illustrations: []
      }));

      util.nextTick(() => {
        designService.getDesignIllustrations(this.props.designId, this.state.page, this.state.searchBy, this.state.folder).then(response => {
          this.setState(() => ({
            illustrations: response.data.map(it => new designDomain.DesignIllustration(it)),
            isLoading: false,
            isSearching: false
          }));
        }).catch(() => {
          this.setState(() => ({
            isLoading: false,
            isSearching: false,
            illustrations: []
          }));
        })
      })
    }
  }

  componentDidMount() {
    this.init();
    $('#delete-icon').hide();
  }

  onChange(event) {
    this.forceUpdate();
    const file = event.target.files[0];
    const data = new FormData();
    data.append('file', file);

    if (file.type === 'image/png') {
      this.uploadImage(data);
    } else {
      this.uploadSvg(data);
    }
  }

  uploadImage(data) {
    this.setState({isUploadLoading: true});
    designService.uploadImageIllustration(this.props.designId, data).then(resp => {
      this.setState({isUploadLoading: false});
      this.setState({illustrations: [new designDomain.DesignIllustration(resp.data), ...this.state.illustrations]});
      this.forceUpdate();

    }, () => {
      this.setState({isUploadLoading: false});
      this.forceUpdate();
    })
  }

  uploadSvg(data) {
    this.setState({isUploadLoading: true});
    designService.uploadIllustration(data).then(resp => {
      const colors = [];
      resp.data.colors.forEach(it => {
        colors.push({color: it, isActive: true})
      });

      this.setState({
        isUploadLoading: false,
        isConfirmModalOpen: true,
        colors,
        objectCount: resp.data.objectCount,
        additionalSize: resp.data.size
      });
      this.forceUpdate();
      $('body').click()
    }, () => {
      this.setState({isUploadLoading: false});
      this.forceUpdate();
    })
  }

  toggleSelected(ev, illustration) {
    ev.stopPropagation();
    const $target = $(ev.target);
    const isCheckbox = ($target.hasClass('checkbox') || $target.parent().hasClass('checkbox'));
    
    if (this.state.isSelectionMode || isCheckbox) {
      if (this.state.selectedIllustrations.includes(illustration)) {
        if (this.state.selectedIllustrations.length === 1) {
          this.setState({ isSelectionMode: false });
        }
        const selectedCopy = [...this.state.selectedIllustrations];
        selectedCopy.splice(selectedCopy.indexOf(illustration), 1);
        this.setState({ selectedIllustrations: selectedCopy });
      } else {
        if (this.state.selectedIllustrations.length === 0) {
          this.setState({ isSelectionMode: true });
        }
        this.setState({ selectedIllustrations: [...this.state.selectedIllustrations, illustration] });
      }
      if (!isCheckbox) {
        const checkbox = $target.closest('.component.template').find('.checkbox input');
        checkbox.prop('checked', !checkbox.prop('checked'));
      }
    }
  }

  deselectAll() {
    this.setState({ selectedIllustrations: [], isSelectionMode: false });
  }
  
  render(props, state) {
    let uploadBox = null;
    if (state.isUploadLoading) {
      uploadBox = <Spinner/>;
    } else {
      uploadBox = <div>
        <input type="file" name="image" onChange={this.onChange.bind(this)} accept="image/*" className="input-file"/>
        <div>
          <a className="btn primary medium">
            <span>Upload Illustrations</span>
          </a>
          <p>... or just drag them from your desktop</p>
        </div>
      </div>
    }

    const illustrationsLoadingSpinner = state.isLoading ? <Spinner/> : null;
    let imageElements;

    if (!state.illustrations || state.illustrations.length === 0 && !state.isLoading) {
      imageElements = <p style="margin-left: 1rem;">No matches found.</p>;
    } else {
      const elements = state.illustrations.map(illustration => {
        const privacyLabel = (illustration.privacy === 'public' ? 'PUBLIC' : 'PRIVATE');

        return (
          <IllustrationCard
            illustration={illustration}
            selectionMode={this.state.isSelectionMode}
            selectedIllustrations={this.state.selectedIllustrations}
            toggleSelected={this.toggleSelected}
            showConfigureIllustrationModal={this.showConfigureIllustrationModal}
            isDesigner={props.isDesigner}
            privacyLabel={privacyLabel}
            isFavorite={illustration.isFavorite}
          />
          // <div className={`component template ${this.state.isSelectionMode ? 'selection-mode' : ''}`} data-component={illustration.isSvg ? 'illustration' : 'image'}>
          //   <div className={`image ${illustration.isSvg ? "" : "ctr"}`} data-component={illustration.isSvg ? 'illustration' : 'image'} data-configuration={illustration.configuration}
          //        data-id={illustration.id}>
          //     {illustration.isSvg && <div className="img-wrap"><img src={illustration.thumbnailPath} alt={''}/></div>}
          //     {!illustration.isSvg && <img style={"width: 100%; height: 100%;"} src={illustration.thumbnailPath} alt={''}/>}
          //     <div className={'actions ' + (this.props.isDesigner ? '' : 'hidden')}>
          //       <span>{privacyLabel}</span>
          //       <a className="icn" onClick={(event) => this.showConfigureIllustrationModal(illustration, event)}>
          //         <svg>
          //           <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-cog"}/>
          //         </svg>
          //       </a>
          //       <div class="checkbox" onClick={(ev) => this.toggleSelected(ev, illustration)}>
          //         <input type="checkbox" checked={this.state.selectedIllustrations.includes(illustration)}></input>
          //       </div>
          //       <FavoriteButton assetId={illustration.id} type="illustration" />
          //     </div>
          //   </div>
          // </div>
        )
      });

      // imageElements = <Masonry updateOnEachImageLoad={true} onImagesLoaded={this.onImagesLoaded} className={'masonry-grid'}>{elements}</Masonry>;
      imageElements = elements
    }

    return (
      <div id="app-aside-illustrations" className={"aside-text" + (props.isDesigner ? " is-designer" : "")}>
        <div className="to-root">
          <a onClick={ () => props.goToRoot() }>
            All graphics
          </a>
          <span class="path">&gt;&nbsp; Illustrations</span>
        </div>
        <div className={'dropbox ' + (props.isDesigner ? '' : 'hidden')}>
          {uploadBox}
        </div>

        <header>
          <div className="input-search-templates">
            <input type="text" className="search-templates" placeholder="Search Illustrations"  value={state.searchBy}
                  onKeyUp={(ev) => {
                      if (ev.key === 'Enter') {
                        var onChangeField = this.onChangeSearchField.bind(ev);
                        onChangeField(ev);
                      }
                    }
                  }
                  onClick={(ev) => this.setState({searchBy: ev.target?.value})}
                  onChange={(ev) => ev.target.value !== '' ? $('#delete-icon').show() : $('#delete-icon').hide()} />
            <svg id="delete-icon" onClick={this.onClickDeleteInputSearch.bind()} className="icon icon-delete-close"><use xlinkHref="#app-icon-delete-close" /></svg>
          </div>
        </header>
        <div className="folders-container">
          <div className="folders">
            <div class="scroll-left" onClick={(ev) => util.scrollLeft(ev)}>
                  <svg>
                      <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
                  </svg>
              </div>
              <div class="scroll-right" onClick={(ev) => util.scrollRight(ev)}>
                  <svg>
                      <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
                  </svg>
            </div>
            <a className={`btn medium ${state.folder === '' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('')}>View All</a>
            <a className={`btn medium ${state.folder === 'accents' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('accents')}>Accents</a>
            <a className={`btn medium ${state.folder === 'borders' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('borders')}>Borders</a>
            <a className={`btn medium ${state.folder === 'dividers' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('dividers')}>Dividers</a>
            <a className={`btn medium ${state.folder === 'holiday' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('holiday')}>Holiday</a>
            <a className={`btn medium ${state.folder === 'social media icons' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('social media icons')}>Social Media</a>
            <a className={`btn medium ${state.folder === 'icons' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('icons')}>Icons</a>
            <a className={`btn medium ${state.folder === 'menu icons' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('menu icons')}>Menu Icons</a>
            <a className={`btn medium ${state.folder === 'nature' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('nature')}>Nature</a>
            <a className={`btn medium ${state.folder === 'food' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('food')}>Food</a>
            <a className={`btn medium ${state.folder === 'drinks' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('drinks')}>Drinks</a>
            <a className={`btn medium ${state.folder === 'kids' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('kids')}>Kids</a>
            <a className={`btn medium ${state.folder === 'kitchen' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('kitchen')}>Kitchen</a>
            <a className={`btn medium ${state.folder === 'text' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('text')}>Text</a>
            <a className={`btn medium ${state.folder === 'sports' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('sports')}>Sports</a>
            <a className={`btn medium ${state.folder === 'backgrounds' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('backgrounds')}>Backgrounds</a>
            <a className={`btn medium ${state.folder === 'qr frames' ? 'primary' : 'secondary1'}`}
              onClick={() => this.getIllustrationsByFolder('qr frames')}>QR Frames</a>
          </div>
        </div>

        <div className={`scroller ${this.state.isSelectionMode ? 'selection-mode-height' : ''}`} onScroll={this.infiniteLoadIllustrations}>
          <div>
            {illustrationsLoadingSpinner}
            <div className="components images illustrations">
              {imageElements}
            </div>
          </div>
        </div>

        {this.state.isSelectionMode && <div className="illustration-footer">
          <div className="btn" onClick={() => this.deselectAll()}>Deselect all</div>
          <div className="btn" onClick={() => this.showConfigureMultiIllustrationModal()}>Configure selected ({this.state.selectedIllustrations.length})</div>
        </div>}

        <IllustrationConfirmModal
          open={state.isConfirmModalOpen}
          colors={state.colors}
          objectCount={state.objectCount}
          additionalSize={state.additionalSize}
          onModalClose={this.onConfirmModalClose}
          onAccept={this.confirmUpload}
          toggleColor={this.toggleColor}
          toggleAllColors={this.toggleAllColors}/>

        <ConfigureIllustrationModal
          open={props.isConfigureIllustrationModal}
          illustrationToConfigure={state.illustrationToConfigure}
          multipleConfigureIllustrations={state.selectedIllustrations}
          onModalClose={this.onConfigureIllustrationModalClose}/>
      </div>
    )
  }
}
